import React from 'react';
import PropTypes from 'prop-types';

import { ServiceListGrid } from '../ServiceListGrid';
import { FlexContainer, ServiceCardWrapper } from '../../components';

import { ServiceCardConnected } from './connected';
import {
  ServiceConnectionRequestStatus, ServiceDisconnectionRequestStatus, ServiceErrorConnected,
  ServiceFutureRequestSuccessStatus, ServiceDisconnectionDialog, ServiceDisconnectSuccessStatus,
} from './containers';

export const AdditionalServicesConnected = ({ isMobile }) => (
  <ServiceListGrid>
    <ServiceListGrid.Item>
      <ServiceListGrid.ItemContainer>
        <ServiceCardConnected isMobile={isMobile}>
          <ServiceCardWrapper isMobile={isMobile}>
            <FlexContainer>
              <ServiceCardConnected.Switch />
              <ServiceCardConnected.Title />
            </FlexContainer>
            <ServiceCardConnected.Params />
          </ServiceCardWrapper>
          <ServiceCardConnected.Additional isMobile={isMobile} />
          <ServiceCardConnected.Price isMobile={isMobile} />
        </ServiceCardConnected>

        <FlexContainer paddingLeft="58px">
          <ServiceDisconnectionDialog />
        </FlexContainer>

        <>
          <ServiceDisconnectSuccessStatus />
          <ServiceDisconnectionRequestStatus />
          <ServiceConnectionRequestStatus />
          <ServiceFutureRequestSuccessStatus />
          <ServiceErrorConnected />
        </>
      </ServiceListGrid.ItemContainer>
    </ServiceListGrid.Item>
  </ServiceListGrid>
);

AdditionalServicesConnected.propTypes = {
  isMobile: PropTypes.bool,
};
